import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { ShieldCheckIcon } from '../../../assets';
import { Heading, HeadingSize } from '../../typography';
import { TableSize } from '../types';
import { SummaryTableRow, SummaryTableRowData } from './SummaryTableRow';

export type SummaryTableProps = {
  data: SummaryTableRowData[];
  name?: string;
  isVerified?: boolean;
  size?: TableSize;
  multiline?: boolean;
  isVerification?: boolean;
};

const Wrapper = styled.div`
  background-color: ${theme.colors.system.systemBlueLite};
  border-radius: ${theme.borderRadius.default};
  box-sizing: border-box;
  padding: ${theme.spacings[2].rem} ${theme.spacings[4].rem};
  &:first-of-type {
    margin-top: ${theme.spacings[4].rem};
  }
`;

const Header = styled.div`
  display: flex;
  padding: ${theme.spacings[2].rem} 0;
`;

const Name = styled(Heading)<{ tableSize: TableSize; size: HeadingSize }>`
  ${({ tableSize, size: headingSize }) =>
    theme.typography.headings[headingSize][
      tableSize === 'small' ? 'sm-lg' : 'xl'
    ]}
`;

const VerifiedIcon = styled(ShieldCheckIcon)`
  fill: ${theme.colors.system.systemGreen};
  margin: 0 ${theme.spacings[2].rem} 3px;
  width: 24px;
`;

export const SummaryTable: React.FC<SummaryTableProps> = ({
  data,
  name,
  isVerified,
  size = 'large',
  multiline = false,
  isVerification,
}) => (
  <Wrapper>
    {name && (
      <Header>
        <Name size={6} tableSize={size}>
          {name}
        </Name>
        {isVerified && <VerifiedIcon />}
      </Header>
    )}
    {data.map((row) => (
      <SummaryTableRow
        isVerification={isVerification}
        size={size}
        key={row.label}
        {...row}
        multiline={multiline}
      />
    ))}
  </Wrapper>
);
